import { render, staticRenderFns } from "./importJsonModal.vue?vue&type=template&id=4490dd6a&scoped=true&"
import script from "./importJsonModal.vue?vue&type=script&lang=js&"
export * from "./importJsonModal.vue?vue&type=script&lang=js&"
import style0 from "./importJsonModal.vue?vue&type=style&index=0&id=4490dd6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4490dd6a",
  null
  
)

export default component.exports